<div class="admin-page-wrap">
  <h1 class="page-title"><i class="bi bi-graph-up me-2"></i> Social analytics</h1>
  <p class="page-subtitle">Read-only retention and social metrics. No learner PII is shown.</p>

  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-2 align-items-end">
        <div class="col-md-3">
          <label class="form-label">From</label>
          <input type="date" class="form-control" [(ngModel)]="fromDate">
        </div>
        <div class="col-md-3">
          <label class="form-label">To</label>
          <input type="date" class="form-control" [(ngModel)]="toDate">
        </div>
        <div class="col-md-3">
          <label class="form-label">Course ID (optional)</label>
          <input type="text" class="form-control" [(ngModel)]="courseId" placeholder="e.g. 100">
        </div>
        <div class="col-md-3">
          <button type="button" class="btn btn-primary w-100" [disabled]="loading" (click)="load()">Refresh</button>
        </div>
      </div>
    </div>
  </div>

  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }
  @if (loading) {
    <p class="text-muted">Loading…</p>
  } @else if (analytics) {
    <div class="row g-3">
      <div class="col-md-4">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="h6 text-muted">Engagement</h2>
            <p class="mb-1"><strong>{{ analytics.dailyActiveLearners }}</strong> daily active learners</p>
            <p class="mb-1">Train next shown: {{ analytics.trainNextShown }}</p>
            <p class="mb-1">Train next accepted: {{ analytics.trainNextAccepted }}</p>
            <p class="mb-0">Acceptance rate: {{ percent(analytics.trainNextAcceptanceRate) }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="h6 text-muted">Reminders</h2>
            <p class="mb-1">Sent: {{ analytics.remindersSent }}</p>
            <p class="mb-1">Opened: {{ analytics.remindersOpened }} ({{ percent(analytics.reminderOpenRate) }})</p>
            <p class="mb-0">Converted: {{ analytics.remindersConverted }} ({{ percent(analytics.reminderConvertRate) }})</p>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card h-100">
          <div class="card-body">
            <h2 class="h6 text-muted">Social graph</h2>
            <p class="mb-1">Pending friend requests: {{ analytics.pendingFriendRequests }}</p>
            <p class="mb-1">Accepted friendships: {{ analytics.acceptedFriendships }}</p>
            <p class="mb-0">Test shares in period: {{ analytics.testSharesInPeriod }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h2 class="h6 text-muted">Streak milestones awarded</h2>
            <p class="mb-0">
              7-day: {{ analytics.streakMilestones7 }} ·
              14-day: {{ analytics.streakMilestones14 }} ·
              30-day: {{ analytics.streakMilestones30 }}
            </p>
          </div>
        </div>
      </div>
    </div>
  }
</div>
